"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OAuthGetOperations", {
    enumerable: true,
    get: function() {
        return OAuthGetOperations;
    }
});
const _common = require("@nestjs/common");
const _oauthclientservice = require("~/modules/oauth/services/oauth-client.service");
const _oauthtokenservice = require("~/modules/oauth/services/oauth-token.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let OAuthGetOperations = class OAuthGetOperations {
    async handle(context, { req, operation }) {
        switch(operation){
            case 'oAuthClientGet':
                return await this.oAuthClientService.getClient(context, {
                    clientId: req.query.clientId,
                    req
                });
            case 'oAuthClientList':
                return await this.oAuthClientService.listClients(context, req);
            case 'oAuthAuthorizationList':
                return await this.oAuthTokenService.listUserAuthorizations(req.user.id);
        }
    }
    constructor(oAuthClientService, oAuthTokenService){
        this.oAuthClientService = oAuthClientService;
        this.oAuthTokenService = oAuthTokenService;
        this.operations = [
            'oAuthClientGet',
            'oAuthClientList',
            'oAuthAuthorizationList'
        ];
        this.httpMethod = 'GET';
    }
};
OAuthGetOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _oauthclientservice.OauthClientService === "undefined" ? Object : _oauthclientservice.OauthClientService,
        typeof _oauthtokenservice.OauthTokenService === "undefined" ? Object : _oauthtokenservice.OauthTokenService
    ])
], OAuthGetOperations);
